import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppResult } from '../../../models';
import { environment } from '../../../../../environments/environment';
import { JwtPacketModel, RefreshTokenModel, LoginModel, ResetPasswordModel } from '../../../models/auths';


const IT_API_URL = `${environment.apiUrl}/api/Auth`;

@Injectable({
   providedIn: 'root',
})
export class AuthHTTPService {
   constructor(private readonly http: HttpClient) { }

   // public methods
   login(model: LoginModel): Observable<AppResult<JwtPacketModel>> {
      return this.http.post<AppResult<JwtPacketModel>>(`${IT_API_URL}/login`, model);
   }

   resetPassword(model: ResetPasswordModel): Observable<AppResult<string>> {
      return this.http.put<AppResult<string>>(`${IT_API_URL}/ResetPassword`, model);
   }

   refreshToken(model: RefreshTokenModel): Observable<AppResult<JwtPacketModel>> {
      return this.http.post<AppResult<JwtPacketModel>>(`${IT_API_URL}/RefreshToken`, model);
   }

   logout(userName: string): Observable<AppResult<string>> {
      return this.http.post<AppResult<string>>(`${IT_API_URL}/logout/${userName}`, { userName });
   }
}
